/* ============================================================
   Mehlography Lab - STYLING article media slider
   - 記事詳細の画像・動画スライダー（DOM 駆動・データ直書きなし）
   - PC: 矢印（ホバー時のみ表示）。スマホ: スワイプ＋進捗バー
   - イベント委譲: スライダー数に依らずリスナーは document に固定数
   - 貼り付け HTML の data 属性 / クラスだけを読む
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-mhl-styling-slider]';
  var SWIPE_THRESHOLD = 40; // px

  function count(slider) {
    var track = slider.querySelector('.mhl-styling-slider__track');
    return track ? track.children.length : 1;
  }

  function wrap(idx, n) {
    return ((idx % n) + n) % n;
  }

  function current(slider) {
    return parseInt(slider.dataset.current, 10) || 0;
  }

  function showControlsWhenPlaybackFails(video, playPromise) {
    if (!playPromise || typeof playPromise.catch !== 'function') return;

    playPromise.catch(function (error) {
      if (!error || error.name !== 'NotAllowedError') return;
      // 自動再生できない環境でも、利用者が手動で再生できるようにする。
      video.controls = true;
    });
  }

  function syncVideos(slider, activeIndex) {
    var slides = slider.querySelectorAll('.mhl-styling-slider__slide');
    for (var i = 0; i < slides.length; i++) {
      var videos = slides[i].querySelectorAll('video');
      for (var j = 0; j < videos.length; j++) {
        var video = videos[j];
        // STYLING動画は常に無音。モバイルでもインライン再生する。
        video.muted = true;
        video.playsInline = true;

        if (i !== activeIndex || document.hidden) {
          video.pause();
          if (i !== activeIndex) video.currentTime = 0;
          continue;
        }

        if (video.hasAttribute('autoplay')) {
          var playPromise = video.play();
          showControlsWhenPlaybackFails(video, playPromise);
        }
      }
    }
  }

  function goTo(slider, idx) {
    var n = count(slider);
    idx = wrap(idx, n);

    var track = slider.querySelector('.mhl-styling-slider__track');
    if (track) track.style.transform = 'translateX(' + -idx * 100 + '%)';
    slider.dataset.current = idx;

    var bar = slider.querySelector('.mhl-styling-slider__bar');
    if (bar) {
      bar.style.width = 100 / n + '%';
      bar.style.transform = 'translateX(' + idx * 100 + '%)';
    }

    syncVideos(slider, idx);
  }

  // 進捗バー初期化（つまみ幅 = 1/枚数）
  function init() {
    var sliders = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < sliders.length; i++) {
      var s = sliders[i];
      if (!s.dataset.current) s.dataset.current = 0;
      // メディア1点のみは矢印・進捗バーを隠す（CSS の --single で制御）
      if (count(s) <= 1) s.classList.add('mhl-styling-slider--single');
      goTo(s, current(s));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---- 矢印クリック ---- */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-mhl-styling-slider-prev]');
    var next = e.target.closest('[data-mhl-styling-slider-next]');
    if (!prev && !next) return;
    var slider = e.target.closest(SELECTOR);
    if (!slider) return;
    e.preventDefault();
    if (prev) goTo(slider, current(slider) - 1);
    else goTo(slider, current(slider) + 1);
  });

  /* ---- タッチスワイプ ---- */
  var startX = 0;
  var startY = 0;
  var activeSlider = null;
  var swiping = false;

  document.addEventListener(
    'touchstart',
    function (e) {
      var slider = e.target.closest(SELECTOR);
      if (!slider) return;
      activeSlider = slider;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!activeSlider) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) swiping = true;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!activeSlider || !swiping) {
        activeSlider = null;
        return;
      }
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > SWIPE_THRESHOLD) {
        goTo(activeSlider, current(activeSlider) + (dx < 0 ? 1 : -1));
      }
      activeSlider = null;
    },
    { passive: true }
  );

  document.addEventListener('visibilitychange', function () {
    var sliders = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < sliders.length; i++) {
      syncVideos(sliders[i], current(sliders[i]));
    }
  });
})();
